<template>
    <div class="container">
        <a-page-header class="page-header icon" @back="() => null" :sub-title="sub_title">
            <svg class="icon" aria-hidden="true" slot="backIcon" @click="$router.replace('/finance')">
                <use xlink:href="#icon-dingdan1" />
            </svg>
            <template #title> 财务管理<a-icon class="separator" type="right" /> </template>

            <template slot="extra">
                <div class="extra-shortcut">
                    <a-icon type="plus-circle" class="pointer" @click="on_add_shortcut" />
                </div>
            </template>
        </a-page-header>

        <div class="framework-container">
            <div
                class="framework-side"
                :class="[visible_sidebar ? 'visible' : '', small_screen ? 'ss' : '', visible_sidebar ? 'tg-on' : 'tg-off']"
            >
                <div class="module-title">
                    财务管理
                </div>
                <a-menu class="menu" mode="inline" :selected-keys="sidebar_finance" :inlineIndent="16">

                    <a-menu-item-group>

                        <a-menu-item key="audit_recharge" @click="on_jump('/audit/recharge')"
                            >审批列表
                            <div style="float: right;">
                                <a-badge :count="data_stat.recharge" :overflowCount="999" class="sidebar-badge" />
                            </div></a-menu-item>
                      <a-menu-item key="audit_refund" @click="on_jump('/audit/refund')"
                      >收款渠道
                        <div style="float: right;">
                          <a-badge :count="data_stat.balance_refund" :overflowCount="999" class="sidebar-badge" />
                        </div></a-menu-item>

                    </a-menu-item-group>
                    <a-menu-divider />


                </a-menu>
            </div>

            <div class="framework-body" :class="[visible_sidebar ? 'tg-on' : 'tg-off', small_screen ? 'ss' : '']">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
    import commonjs from "./mixins/common";

    export default {
        mixins: [commonjs],
        data() {
            return {
                sub_title: "财务管理",
                data_summary: {},
            };
        },
        created() {
            this.load_stat();

            this.$store.commit("change_state", {
                name: "sidebar_key",
                value: "finance",
            });
        },

        computed: {
            data_stat() {
                return this.$store.state.stat_finance;
            },
            sidebar_finance() {
                return [this.$store.state.sidebar_finance];
            },
        },
        methods: {
            on_jump(v) {
                return this.$router.push(`/finance${v}`);
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-container {
        .framework-side {
            .toolbar {
                .item {
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;
                    cursor: pointer;
                    .text {
                        font-size: 12px;
                    }
                }
            }
        }
        .framework-body {
            position: absolute;
            right: 0;
            bottom: 0;
            top: 0;
            left: 200px;
        }
    }
</style>
